import { Component, inject, signal } from '@angular/core';
import { form, FormField, maxLength, minLength, required } from '@angular/forms/signals';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'mce-management-otp-dialog',
  imports: [FormField, MatButtonModule, MatDialogModule, MatFormFieldModule, MatInputModule],
  templateUrl: './management-otp-dialog.component.html',
})
export class ManagementOtpDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<ManagementOtpDialogComponent, string>);
  protected readonly model = signal({ otp: '' });
  protected readonly otpForm = form(this.model, path => {
    required(path.otp, { message: 'Enter the one time password.' });
    minLength(path.otp, 6, { message: 'Enter the 6 character password.' });
    maxLength(path.otp, 6, { message: 'Enter the 6 character password.' });
  });

  protected verify(): void {
    if (this.otpForm().valid()) this.dialogRef.close(this.model().otp);
  }
}
